namespace Matrix.Rebalancer {
    export interface ModellingViewColumnForm {
        ColumnSetCode: Serenity.StringEditor;
        ChildView: Serenity.BooleanEditor;
        FieldName: Serenity.StringEditor;
        Header: Serenity.StringEditor;
        SortOrder: Serenity.IntegerEditor;
        Expression: Serenity.StringEditor;
        DataType: Serenity.LookupEditor;
        FormatString: Serenity.LookupEditor;
        Alignment: Serenity.LookupEditor;
        GroupIndex: Serenity.IntegerEditor;
        SortFieldName: Serenity.StringEditor;
        GroupSummary: Serenity.StringEditor;
        GroupSummaryFormat: Serenity.StringEditor;
        TotalSummary: Serenity.StringEditor;
        TotalSummaryFormat: Serenity.LookupEditor;
        ReadOnly: Serenity.BooleanEditor;
        Visible: Serenity.BooleanEditor;
        Frozen: Serenity.BooleanEditor;
        IsDetail: Serenity.BooleanEditor;
        ActionTemplate: Serenity.StringEditor;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
        Version: StaticTextBlock;
    }

    export class ModellingViewColumnForm extends Serenity.PrefixedContext {
        static formKey = 'Rebalancer.ModellingViewColumn';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ModellingViewColumnForm.init)  {
                ModellingViewColumnForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.BooleanEditor;
                var w2 = s.IntegerEditor;
                var w3 = s.LookupEditor;
                var w4 = StaticTextBlock;
                var w5 = ReadOnlyDateTime;

                Q.initFormType(ModellingViewColumnForm, [
                    'ColumnSetCode', w0,
                    'ChildView', w1,
                    'FieldName', w0,
                    'Header', w0,
                    'SortOrder', w2,
                    'Expression', w0,
                    'DataType', w3,
                    'FormatString', w3,
                    'Alignment', w3,
                    'GroupIndex', w2,
                    'SortFieldName', w0,
                    'GroupSummary', w0,
                    'GroupSummaryFormat', w0,
                    'TotalSummary', w0,
                    'TotalSummaryFormat', w3,
                    'ReadOnly', w1,
                    'Visible', w1,
                    'Frozen', w1,
                    'IsDetail', w1,
                    'ActionTemplate', w0,
                    'CreatedBy', w4,
                    'CreatedWhen', w5,
                    'UpdatedBy', w4,
                    'UpdatedWhen', w5,
                    'Version', w4
                ]);
            }
        }
    }
}
